import * as React from 'react';

import { cn } from '@/_shared/lib/utils';

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      // Mirror the Input styling so a textarea reads as the same control, just taller.
      className={cn(
        'field-sizing-content min-h-16 w-full min-w-0 rounded-md border border-grey-75 bg-grey-0 px-2 py-1 text-base font-medium text-grey-800 transition-[color,box-shadow,border-color] outline-none md:text-sm',
        'selection:bg-primary selection:text-primary-foreground placeholder:font-normal placeholder:text-grey-300',
        'hover:border-grey-200 hover:shadow-secondary',
        'focus:border-primary focus:shadow-primary',
        'aria-invalid:border-destructive aria-invalid:hover:border-destructive aria-invalid:hover:shadow-destructive aria-invalid:focus:border-destructive aria-invalid:focus:shadow-destructive',
        'disabled:cursor-not-allowed disabled:border-transparent disabled:bg-grey-25 disabled:text-grey-400 disabled:hover:border-transparent disabled:hover:shadow-none',
        'read-only:bg-grey-25 read-only:text-grey-400 read-only:hover:border-grey-75 read-only:focus:border-grey-75 read-only:focus:shadow-secondary',
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
